export default __webpack_public_path__ + "static/media/06.a29d2c0d.svg";